import axios from '@/http/axios/index.js'


export default {
    getDocuments(payload) {
        return axios.get('rps/documents', { params: payload }).then(res => res.data)
    }
}